import {ColumnCheckboxParams} from "../types/table-column-checkbox.types";

export const defaultColumnCheckboxParams: ColumnCheckboxParams = {
  completed: false,
  subtasks: []
};
